<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('preInvoice.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <ts-button
              outline
              color="info"
              @click="$router.push({ name: 'pre-invoice-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <a-range-picker
              style="width: 280px; margin-left: 12px;"
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              @change="dateRangeChange"
            >
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
          </div>
          <div class="d-flex">
            <ts-input
              :placeholder="$t('preInvoice.search')"
              style="width: 350px"
              v-model="search"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('preInvoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.pre_invoice_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.pre_invoice_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.full_name_en }}
              <span
                v-if="record.is_new_student"
                class="ts-bg-red-100 ts-px-1 ts-rounded-lg ts-text-red-500 ts-text-xs"
                >{{ $t('paymentNotice.new') }}</span
              >
              <span
                v-else
                class="ts-bg-gray-100 ts-px-1 ts-rounded-lg ts-text-gray-600 ts-text-xs"
                >{{ $t('paymentNotice.old') }}</span
              >
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.sub_program ? record.sub_program.acps_name_foreign : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.grade ? record.grade.grade_name_foreign : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.year }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.semester }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.total_amount }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span v-if="record.is_approved == 1" class="label label-success"
                >Approved</span
              >
              <span v-else class="label label-danger">Pending</span>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.remark }}
            </td>
            <td class="ts-whitespace-no-wrap text-center ts-flex ts-space-x-2">
              <a
                href="#"
                v-tooltip="$t('tooltip.approve')"
                class="text-primary ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-bg-blue-100 ts-rounded-full hover:ts-no-underline"
                v-show="record.is_approved == 0"
                @click.prevent="showApprove(record)"
              >
                <i class="fas fa-check"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-bg-blue-100 ts-rounded-full hover:ts-no-underline"
                v-show="record.is_approved == 0"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-pen"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.show')"
                class="text-primary ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-bg-blue-100 ts-rounded-full hover:ts-no-underline"
                @click.prevent="showRecord(record)"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('pdf')"
                class="text-danger ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-bg-red-100 ts-rounded-full hover:ts-no-underline"
                @click.prevent="pdfView(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-file-pdf" v-else></i>
              </a>
              <a
                v-show="record.is_approved == 0"
                href="#"
                class="ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-bg-red-100 ts-rounded-full hover:ts-no-underline"
                @click.prevent="deleteRecord(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-drawer
        :title="$t('preInvoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>{{ $t('preInvoice.branch') }}</label>
              <a-select
                style="width: 257px"
                v-model="model.branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
            <div class="form-group">
              <label>{{ $t('preInvoice.subProgram') }}</label>
              <a-select
                style="width: 257px"
                v-model="model.acps_id"
                :options="subprograms"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
            <div class="form-group">
              <label>{{ $t('preInvoice.grade') }}</label>
              <a-select
                style="width: 257px"
                v-model="model.grade_id"
                :options="grades"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
            <div class="form-group">
              <label>{{ $t('preInvoice.status') }}</label>
              <a-select
                style="width: 257px"
                v-model="model.status_id"
                :options="statuses"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
              >
              </a-select>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ts-checkbox v-model="model.is_deleted">Voided</ts-checkbox>
              </div>
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

import { debounce } from 'lodash'
import { PreviewPDF, Reason } from './components'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'preInvoice',
  data() {
    return {
      search: '',
      resources: [],
      branchs: [],
      grades: [],
      subprograms: [],
      loading: false,
      pagination: new Pagination(),
      visible: false,
      statuses: [
        {
          value: 1,
          label: 'Approved'
        },
        {
          value: 0,
          label: 'Pending'
        }
      ],
      model: {
        is_deleted: false,
        branch_id: undefined,
        acps_id: undefined,
        grade_id: undefined,
        status_id: undefined,
        void_reason: null
      },
      rangeDate: [moment(), moment()]
    }
  },
  computed: {
    columns() {
      return [
        { name: this.$t('preInvoice.preInvoiceDate') },
        { name: this.$t('preInvoice.preInvoiceNumber') },
        { name: this.$t('preInvoice.cardNumber') },
        { name: this.$t('preInvoice.studentName') },
        { name: this.$t('preInvoice.subProgram') },
        { name: this.$t('preInvoice.grade') },
        { name: this.$t('preInvoice.year') },
        { name: this.$t('preInvoice.semester') },
        { name: this.$t('preInvoice.totalAmount'), style: 'text-align:center' },
        { name: this.$t('preInvoice.status'), style: 'text-align:center' },
        { name: this.$t('preInvoice.remark'), style: 'width:27%' },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData({
      page: 1,
      perPage: 15,
      is_deleted: false,
      date_from: moment().format('DD-MM-YYYY'),
      date_to: moment().format('DD-MM-YYYY')
    })
    this.fetchResource()
  },
  methods: {
    ...mapActions('paymentNoticeModule', [
      'onGetSubprogram',
      'onGetGrade',
      'onDeleteRecord'
    ]),
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('paymentNoticeModule/onFetch', Object.assign({}, attributes))
        .then(response => {
          this.resources = response.data.data
          this.RECEIVE_RESOURCES(response.data)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.response.data.message)
        })
    },
    fetchResource() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })

      this.onGetSubprogram().then(response => {
        this.subprograms = response.data.data.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
      })

      this.onGetGrade().then(response => {
        this.grades = response.data.data.map(el => ({
          value: el.grade_id,
          label:
            el.grade_name_foreign +
            (el.level ? '|' + el.level.level_name_foreign : '')
        }))
      })
    },
    RECEIVE_RESOURCES(records) {
      const { data, ...meta } = records
      this.resources = data
      this.$nextTick(() => {
        this.pagination.currentPage = meta.meta.current_page
        this.pagination.lastPage = meta.meta.last_page
        this.pagination.perPage = meta.meta.per_page
        this.pagination.total = meta.meta.total
        this.pagination.from = meta.meta.from
        this.pagination.to = meta.meta.to
      })
    },
    dateRangeChange(dateRange) {
      if (dateRange.length > 0) {
        this.$store.commit(
          'paymentNoticeModule/SET_DATE_FROM',
          dateRange[0].format('DD-MM-YYYY')
        )
        this.$store.commit(
          'paymentNoticeModule/SET_DATE_TO',
          dateRange[1].format('DD-MM-YYYY')
        )
      } else {
        this.$store.commit('paymentNoticeModule/SET_DATE_FROM', undefined)
        this.$store.commit('paymentNoticeModule/SET_DATE_TO', undefined)
      }
      this.fetchData({
        search: this.search,
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        status_id: this.model.status_id,
        is_deleted: this.model.is_deleted
      })
    },
    showRecord(record) {
      this.$store.commit('paymentNoticeModule/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'pre-invoice-show',
        params: {
          id: record.inv_id
        }
      })
    },
    showApprove(record) {
      this.$store.commit('paymentNoticeModule/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'pre-invoice-approve',
        params: {
          id: record.inv_id
        }
      })
    },
    pdfView(record) {
      this.$modal.show(
        PreviewPDF,
        {
          url: null,
          inv_id: record.inv_id
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    deleteRecord(record) {
      this.model.void_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.model,
              validate: this.errors,
              placeholder: this.$t('preInvoice.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.onDeleteRecord({
            id: record.inv_id,
            void_reason: this.model.void_reason
          })
            .then(response => {
              this.$toasted.success(response.data.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.response.data.message)
              this.errors = new Errors(error.response.data.errors)
              return Promise.reject(error.response.data)
            })
        },
        onCancel() {}
      })
    },
    edit(record) {
      this.$router.push({
        name: 'pre-invoice-edit',
        params: { id: record.inv_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({
        search,
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        status_id: this.model.status_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.branch_id': debounce(function(value) {
      this.fetchData({
        branch_id: value,
        search: this.search,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        status_id: this.model.status_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.acps_id': debounce(function(value) {
      this.fetchData({
        acps_id: value,
        search: this.search,
        branch_id: this.model.branch_id,
        grade_id: this.model.grade_id,
        status_id: this.model.status_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.grade_id': debounce(function(value) {
      this.fetchData({
        grade_id: value,
        search: this.search,
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        status_id: this.model.status_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.status_id': debounce(function(value) {
      this.fetchData({
        status_id: value,
        search: this.search,
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    'model.is_deleted': debounce(function(value) {
      this.fetchData({
        is_deleted: value,
        search: this.search,
        branch_id: this.model.branch_id,
        acps_id: this.model.acps_id,
        grade_id: this.model.grade_id,
        status_id: this.model.status_id
      })
    }, 500)
  }
}
</script>
